import styled, { css } from 'styled-components';

import { rem } from 'approot/shared/style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { grey1, grey5 } from 'approot/shared/styles/colours.style';
import { spacing12, spacing4 } from 'approot/shared/styles/spacing.style';

export const printQrContainerBase = css`
  background-color: ${grey1};
  border-radius: ${rem(borderRadius8)};
  border: 1px solid ${grey5};
  box-shadow:
    0px 4px 8px -4px rgba(22, 34, 51, 0.08),
    0px 16px 24px rgba(22, 34, 51, 0.08);
  padding: ${rem(spacing4)};
  position: absolute;
  top: ${rem(spacing12)};
  left: ${rem(spacing12)};
  min-width: ${rem(64)};
  min-height: ${rem(64)};
  max-width: ${rem(100)};
  max-height: ${rem(100)};
  width: 100%;
  height: 100%;
  z-index: 1;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const PrintQrContainer = styled.div`
  ${printQrContainerBase}
`;

export const PrintQrContainerLink = styled.a`
  ${printQrContainerBase}
`;
